import React from 'react';
import ITStaffAugmentation from './ITStaffAugmentation';

const StaffAugmentationPage: React.FC = () => {
  return (
    <div className="py-20">
      <div className="container mx-auto px-4">
        <ITStaffAugmentation />
      </div>
    </div>
  );
};

export default StaffAugmentationPage;